import React from "react";

const IconContainer = ({ children, size = "md", className = "" }) => {
  const sizes = {
    sm: "w-10 h-10",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-20 h-20",
  };

  return (
    <div
      className={`${sizes[size]} card-gradient rounded-full flex items-center justify-center shadow-md ${className}`}
    >
      {children}
    </div>
  );
};

export default IconContainer;
